import React, { useState } from 'react';
import { Gift, ChevronDown, Check } from 'lucide-react';
const bonuses = [{
  icon: '🎁',
  title: 'BONUS 1 – 100 EJERCICIOS LISTOS PARA USAR',
  items: ['Nunca más te quedes sin ideas para una clase', '100 ejercicios organizados por objetivo, nivel y situación de juego.']
}, {
  icon: '🎮',
  title: 'BONUS 2 – 50 JUEGOS PARA CLASES DINÁMICAS',
  items: ['Convertí cada clase en una experiencia divertida', 'Juegos listos para aumentar participación, motivación y aprendizaje.']
}, {
  icon: '📅',
  title: 'BONUS 3 – PLANIFICACIÓN ANUAL RESUELTA',
  items: ['Tu calendario de trabajo completo', 'Todo el año organizado para que no tengas que empezar de cero cada semana.']
}, {
  icon: '🎯',
  title: 'BONUS 4 – CORRECCIONES RÁPIDAS EN CANCHA',
  items: ['Qué corregir, cómo corregir y qué decir', 'Un atajo profesional para mejorar tus intervenciones durante la clase.']
}, {
  icon: '⏱️',
  title: 'BONUS 5 – CLASES EXPRESS PARA PROFES OCUPADOS',
  items: ['Sesiones listas de 30, 45 y 60 minutos', 'Abrís el PDF, elegís una clase y la aplicás inmediatamente.']
}, {
  icon: '🤝',
  title: 'BONUS 6 – SISTEMA PARA FIDELIZAR ALUMNOS',
  items: ['Más permanencia, más recomendaciones y más ingresos', 'Estrategias simples para que tus alumnos quieran seguir entrenando con vos mes tras mes.']
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? -1 : i);
  };
  const scrollToPricing = () => {
    const el = document.getElementById('precio-lanzamiento');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-20 px-4 bg-[#0F1F3D] relative overflow-hidden" data-id="element-17">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C6F432] to-transparent" data-id="element-18"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-19">
        <div className="text-center mb-10" data-id="element-20">
          <div className="inline-flex items-center gap-2 bg-red-500 text-white font-black px-5 py-2 rounded-full mb-5 animate-pulse uppercase tracking-wider text-sm" data-id="element-21">
            <Gift size={16} data-id="element-22" /> Gratis por hoy
          </div>
          <h2 className="text-4xl md:text-5xl font-anton text-white mb-3 leading-tight" data-id="element-23">
            🎁 LOS BONOS ESTRATÉGICOS
          </h2>
          <p className="text-base md:text-lg text-gray-300" data-id="element-24">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3" data-id="element-25">
          {bonuses.map((bonus, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'bg-[#0A1628] border-2 border-[#C6F432] shadow-[0_0_25px_rgba(198,244,50,0.15)]' : 'bg-[#0A1628] border border-white/10 hover:border-[#C6F432]/40'}`} data-id="element-26">
                <button onClick={() => toggle(i)} className="w-full flex items-center gap-3 p-4 md:p-5 text-left" aria-expanded={isOpen} data-id="element-27">
                  <span className="text-2xl shrink-0" data-id="element-28">{bonus.icon}</span>
                  <h3 className="flex-1 font-anton text-sm md:text-base text-white leading-tight tracking-wide line-clamp-2" data-id="element-29">
                    {bonus.title}
                  </h3>
                  <span className="bg-[#C6F432]/15 border border-[#C6F432]/40 text-[#C6F432] font-bold text-xs px-2.5 py-1 rounded-full shrink-0" data-id="element-30">
                    GRATIS
                  </span>
                  <ChevronDown className={`text-[#C6F432] shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-31" />
                </button>

                <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-32">
                  <div className="overflow-hidden" data-id="element-33">
                    <ul className="px-5 pb-5 pt-1 space-y-2.5 border-t border-white/5" data-id="element-34">
                      {bonus.items.map((item, j) => <li key={j} className="flex items-start gap-2.5 text-gray-200 text-sm md:text-base" data-id="element-35">
                          <Check className="text-[#C6F432] shrink-0 mt-0.5" size={16} data-id="element-36" />
                          <span data-id="element-37">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Final highlight block */}
        <button onClick={scrollToPricing} className="mt-8 w-full bg-gradient-to-r from-[#C6F432] to-[#B8E821] text-[#0A1628] rounded-2xl p-5 md:p-6 text-center hover:shadow-[0_0_40px_rgba(198,244,50,0.4)] transition-shadow" data-id="element-38">
          <p className="text-sm md:text-base font-bold mb-1 opacity-80" data-id="element-39">
            🎁 Valor total de los 6 bonos: ALTO VALOR
          </p>
          <p className="text-2xl md:text-3xl font-anton flex items-center justify-center gap-2" data-id="element-40">
            <Gift size={28} data-id="element-41" /> GRATIS — Incluidos siempre
          </p>
        </button>
      </div>
    </section>;
}